export default __webpack_public_path__ + "static/media/rocket_anim_30.2ca51216.png";